import { type WeeklySummaryRecipientResponse } from "../api";
import { Utility } from "./utility";

export interface WeeklySummaryRecipient extends WeeklySummaryRecipientResponse {}

export class WeeklySummaryRecipient extends Utility<WeeklySummaryRecipient> {
  constructor(init?: Partial<WeeklySummaryRecipient>) {
    super();
    Object.assign(this, init);
  }
}
